import {toNumber} from "lodash";

const {isHcps} = GLOBAL;
const {latitude, longitude} = LOC?.mapSettings.defaultCoords || {}

export default () => ({
    ageSelected: '',
    coords: {
        lat: toNumber(latitude || 0),
        lng: toNumber(longitude || 0),
    },
    defaultCoords: {
        lat: toNumber(latitude || 0),
        lng: toNumber(longitude || 0),
    },
    locationName: '',
    loading: false,
    query: {
        search: '',
        page: 1,
        ppp: 5,
        lat: toNumber(latitude || 0),
        lng: toNumber(longitude || 0),
        isHcps,
    },
    resultsValues: {
        maxPages: 0,
        noTrialsFound: false,
        page: 0,
        posts: [],
        total: 0,
    },
    searchedText: '',
    sexSelected: '',
    statusSelected: '',
    trialIds: [],
})
